export default __webpack_public_path__ + "static/gallery_mockup-7adf24d2fc61d5ea112be70e8210ef49.png";